import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { ImageIcon, ChevronRightIcon, Modal, ModalNavBar } from '@node-space/storybook-components'
import { Currencies } from 'types/types'
import { useFeatureFlags } from '@node-space/hooks'

interface CurrencySelectProps {
  modalOpen: boolean
  onClose: () => void
  onCurrencySelect: (value: string) => void
}

export const CurrencySelectModal = ({
  modalOpen,
  onClose,
  onCurrencySelect,
}: CurrencySelectProps) => {
  const { t } = useTranslation()
  const { enableNgnBeneficiaries } = useFeatureFlags()

  const availableCurrencies = useMemo(() => {
    const currencies: Currencies[] = [Currencies.EUR, Currencies.GBP, Currencies.ZAR]

    if (enableNgnBeneficiaries) {
      currencies.push(Currencies.NGN)
    }

    return currencies
  }, [enableNgnBeneficiaries])

  return (
    <Modal
      visible={modalOpen}
      closeOnBackgroundClick={false}
      closeModal={() => {
        onClose()
      }}
    >
      <ModalNavBar title={t('settingsBankAccountAddBankAccount')} onClose={() => onClose()} />
      {availableCurrencies.map(currencyCode => (
        <div
          key={`currency-item-${currencyCode}`}
          className="flex justify-between hover:bg-gray-25 py-4 cursor-pointer border-b"
          onClick={() => onCurrencySelect(currencyCode)}
        >
          <div className="flex flex-row items-center px-4 space-x-4 ">
            <div className="my-5 ml-1 mr-3">
              <ImageIcon
                width={28}
                height={28}
                src={`${process.env.ICONS_URL}${currencyCode.toLowerCase()}.svg`}
              />
            </div>
            <div>
              <p className="text-heading">
                {t(`settingsBankAccountCurrencyHeading${currencyCode}`)}
              </p>
              <p>{t(`settingsBankAccountCurrencyDescription${currencyCode}`)}</p>
            </div>
            <ChevronRightIcon />
          </div>
        </div>
      ))}
    </Modal>
  )
}
